<template>
  <div>
    <create
      :ref="createModalName"
      @created="onCreateConfirm"
      @canceled="onCreateCancel"
      :lockPlaceSelection="true"
      :placeId="place.id"
    />
    <update
      v-if="selectedVisit"
      :ref="updateModalName"
      @updated="onUpdateConfirm"
      @canceled="onUpdateCancel"
      :lockPlaceSelection="true"
      :resource="selectedVisit"
    />
    <content-loading
      :active.sync="getVisitsRequest.loading"
      :is-full-page="false"
    />
    <div class="d-flex">
      <p class="page-subtitle my-auto">Archivio visite</p>
      <button
        class="btn btn-primary ml-auto my-auto"
        v-if="canRegister"
        @click="showModal(createModalName, true)"
      >
        Registra visita
      </button>
    </div>

    <table class="table table-responsive mt-4" v-if="!loading && visits.length">
      <thead class="thead-light">
        <tr>
          <th class="pl-0">
            <p class="mb-0">Data</p>
          </th>
          <th class="pl-0">
            <p class="mb-0">Tipologia</p>
          </th>
          <th class="notes">
            <p class="mb-0">Note</p>
          </th>
          <th>
            <p class="mb-0">Agente</p>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <visit-row
          :visit="visit"
          v-for="visit in visits"
          :key="visit.id"
          @click.native="onVisitClicked(visit)"
          class="clickable"
        />
      </tbody>
    </table>
    <div class="d-flex p-5 w-100" v-if="!visits.length">
      <p class="m-auto">Non c'è nessuna visita qui</p>
    </div>

    <div class="d-flex w-100">
      <paginator
        v-if="getVisitsRequest.meta"
        :meta="getVisitsRequest.meta"
        :range="5"
        :loading="getVisitsRequest.loading"
        @change="onPageChange"
        class="mx-auto"
      >
        <template v-slot:left-arrow>
          <i class="fa fa-arrow-left"></i>
        </template>
        <template v-slot:right-arrow>
          <i class="fa fa-arrow-right"></i>
        </template>
      </paginator>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from "vue-property-decorator";
import VisitsMixin from "mixins/http/VisitsMixin";
import { RegisterHttp } from "utils/Decorators";
import { Getter } from "vuex-class";
import { RequestData } from "store/types";
import Create from "components/Visit/Create.vue";
import Update from "components/Visit/Update.vue";
import DataTable from "@monade/vue-components/src/components/DataTable.vue";
import { Visit, Place, User } from "../../models";
import Paginator from "@monade/vue-components/src/components/Paginator.vue";
import Loader from "vue-spinner/src/PulseLoader.vue";
import VisitRow from "components/Visit/TableRow.vue";

@Component({
  components: { DataTable, Loader, VisitRow, Create, Update, Paginator },
})
export default class VisitList extends Mixins(VisitsMixin) {
  static readonly getVisitsTag = "get_visits";

  readonly createModalName = "createVisitModal";
  readonly updateModalName = "updateVisitModal";

  @RegisterHttp(VisitList.getVisitsTag) getVisitsRequest: RequestData;

  @Prop()
  filter: any;

  @Prop()
  place: Place;

  @Getter currentUser?: User;

  selectedVisit?: Visit = null;

  visits: Visit[] = [];

  page: number = 1;

  private loading: boolean = false;

  onCreateConfirm(data) {
    this.showModal(this.createModalName, false);
    this.loadVisits();
  }

  onPageChange(page) {
    this.page = page;
    this.loadVisits();
  }

  onVisitClicked(visit) {
    if (this.currentUser.id !== visit.author.id) return;

    this.selectedVisit = visit;

    this.$nextTick(() => {
      this.showModal(this.updateModalName, true);
    });
  }

  get canRegister() {
    return !this.currentUser.isOneOf(["technician", "executive", "admin"]);
  }

  showModal(name: string, show: boolean) {
    const modal = this.$refs[name] as any;
    show ? modal.show() : modal.hide();
  }

  onCreateCancel(data) {
    this.showModal(this.createModalName, false);
  }

  onUpdateConfirm(data) {
    this.selectedVisit = null;
    this.showModal(this.updateModalName, false);
    this.loadVisits();
  }

  onUpdateCancel(data) {
    this.selectedVisit = null;
    this.showModal(this.updateModalName, false);
  }

  mounted() {
    this.loadVisits();
  }

  get params() {
    let data = {
      filter: {
        ...this.filter,
      },
      page: this.page,
    };

    return data;
  }

  loadVisits() {
    this.loading = true;
    this.getVisits(this.params, VisitList.getVisitsTag).then(
      (resp) => {
        this.visits = resp;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      },
    );
  }
}
</script>

<style scoped>
th.test {
  width: 50%;
}

td.test {
  width: 50%;
}
</style>
